import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import classnames from 'classnames';
import Colors from "../../Color/Colors";
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { Market } from "../../Utility/Market";
import { FlagIcon } from "../../Icon/FlagIcon/FlagIcon";
import { IconButton } from "../../Button/IconButton/IconButton";
import { TokenText } from "../../Text/TokenText/TokenText";
import { Text } from "../../Text/Text/Text";
import styles from "./GeoBanner.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var geoBannerDefaultProps = {
  onClosePress: function onClosePress() {},
  separatorLink: 'or'
};
export var GeoBanner = function GeoBanner(_ref) {
  var closeMessage = _ref.closeMessage,
    geobannerLinks = _ref.geobannerLinks,
    locationCountryCode = _ref.locationCountryCode,
    message = _ref.message,
    _ref$onClosePress = _ref.onClosePress,
    onClosePress = _ref$onClosePress === void 0 ? geoBannerDefaultProps.onClosePress : _ref$onClosePress,
    siteCountryCode = _ref.siteCountryCode,
    siteCountryLanguage = _ref.siteCountryLanguage,
    _ref$separatorLink = _ref.separatorLink,
    separatorLink = _ref$separatorLink === void 0 ? geoBannerDefaultProps.separatorLink : _ref$separatorLink;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var getTokenLink = function getTokenLink(countryCode) {
    var languages = Market.getCountryLanguageCodes(countryCode);
    var links = languages.map(function (language, key) {
      var countryName = Market.getCountryName(countryCode, language);
      var _ref2 = geobannerLinks ? geobannerLinks[key] : [{}][key],
        url = _ref2.url,
        otherProps = _objectWithoutProperties(_ref2, _excluded);
      var button = /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        url: url,
        type: "no-style",
        className: styles.link
      }, otherProps), {}, {
        children: countryName
      }));
      if (key === 0) {
        return /*#__PURE__*/_jsx("span", {
          children: button
        }, language);
      }
      return /*#__PURE__*/_jsxs("span", {
        children: [' ', separatorLink, " ", button]
      }, language);
    });
    return links;
  };
  var openBanner = function openBanner() {
    setOpen(true);
  };
  var closeBanner = function closeBanner() {
    setOpen(false);
    onClosePress();
  };

  // Get site country name using siteCountryCode and siteCountryLanguage.
  var siteCountryName = Market.getCountryName(siteCountryCode ? siteCountryCode : 'us', siteCountryLanguage ? siteCountryLanguage : 'en');
  var tokenRegEx = new RegExp('({{link}})', 'g');
  var tokenItems = {
    '{{link}}': getTokenLink(locationCountryCode ? locationCountryCode : 'us')
  };
  useEffect(function () {
    openBanner();
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.wrapper, {
      [styles.open]: open
    }),
    "data-e2e-name": "geobanner_wrapper",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.country,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.flag,
            children: /*#__PURE__*/_jsx(FlagIcon, {
              countryCode: siteCountryCode,
              label: siteCountryName
            })
          }), /*#__PURE__*/_jsx(Text, {
            typog: 'subhead5',
            className: styles.countryName,
            "data-e2e-name": "geobanner_country_name",
            children: siteCountryName
          })]
        }), /*#__PURE__*/_jsx(Text, {
          typog: 'bodycopySmall',
          className: styles.message,
          "data-e2e-name": "geobanner_message",
          children: /*#__PURE__*/_jsx(TokenText, {
            text: message,
            tokens: tokenItems,
            format: tokenRegEx
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.close,
          children: /*#__PURE__*/_jsx(IconButton, {
            "aria-label": closeMessage,
            onClick: closeBanner,
            icon: "close",
            size: '14px',
            fill: Colors.colorBlack,
            "data-e2e-name": "geobanner_close_button"
          })
        })]
      })
    })
  });
};